<template>
    <csp-desktop-info-card
        v-if="formContext.isLoaded"
        :cols="cols"
        :form-context="formContext"
        icon="inticon-autoclaim_document_accident"
        title="Individuelle Dokumente"
        @save="saveFirmDocuments">
        <csp-desktop-info-card-element
            :form-context="formContext"
            label="Individuelle Dokumente"
            property="firmDocuments"
            stacked
            type="checkboxGroup"/>
    </csp-desktop-info-card>
</template>

<script>
    import Container from '@services/Container';
    import FormDataMixin from '@desktop/components/mixins/FormDataMixin';

    const container = Container.getInstance();
    const firmRepository = container.getDesktopFirmRepository();

    export default {
        name: 'FirmDocuments',
        mixins: [FormDataMixin],
        props: {
            cols: {
                type: Number,
                default: 12,
            },
        },
        computed: {
            firmId() {
                return this.$route.params.firmId;
            },
        },
        methods: {
            saveFirmDocuments(formContext) {
                const saveFunction = (objectId, postData) => {
                    return firmRepository.saveFirmDocuments(this.firmId, postData);
                };
                this.saveFormData(formContext, saveFunction);
            },
        },
    }
</script>
